class SwiperTabsClass {
  constructor(tabset) {
    this.tabset = tabset;
    this.initTabs();
    this.initDropdown();
    
    // Detect screen width and adjust layoutType dynamically
    const isMobile = window.innerWidth <= 768; // Example breakpoint for mobile
    this.layoutType = isMobile ? "horizontal" : (tabset.dataset.layout || "horizontal");
    
   if (this.layoutType === "horizontal") {
      this.initSwiper();
      this.initSyncWithSwiper();
    }

    // Initialize the correct tab based on current URL
    this.highlightCurrentTab();
  }

  initSwiper() {
    const cont = this.tabset.querySelector('.mySwiper');
    if(!cont){
      return;
    }
    const slidesPerView = parseInt(cont.dataset.sliderCount) || 3;
    

    this.swiper = new Swiper(cont, {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: slidesPerView, 
        },
      },
    });
  }


  highlightCurrentTab() {
    const currentPath = window.location.pathname;
    const currentTitle = document.title;
    const tabs = this.tabset.querySelectorAll('.tab-header input');
    const panels = this.tabset.querySelectorAll('.tab-panels .tab-panel-content');
    
    let found = false;
    
    tabs.forEach((tab, index) => {
      const tabUrl = tab.dataset.url;
      const tabIndex = parseInt(tab.dataset.index, 10) - 1;
      const tabTitle = tab.dataset.title;

      if(!found){
        if ((tabUrl && currentPath.includes(tabUrl)) || 
            (tabTitle && currentTitle.includes(tabTitle))) {
     
          tab.checked = true;
          this.applyHighlight(index);
          found = true;
       
          if (this.swiper) {
            this.swiper.slideTo(index, 0, false); // Navigate without animation
          }
        }
      }
        
    });
  
    if (!found && tabs.length > 0) {
      tabs[0].checked = true;
      this.applyHighlight(0); 
    }
  }

applyHighlight(index) {
  const panels = this.tabset.querySelectorAll('.tab-panels .tab-panel-content');
  const tabsWrapper = this.tabset.querySelectorAll('.tabs-wrapper');
  const stackedWrapper = this.tabset.querySelectorAll('.stacked-wrapper');
  const swiperSlides = this.tabset.querySelectorAll('.swiper-slide');

   panels.forEach(panel => panel.classList.remove('active'));
   panels[index].style.display = 'flex'; 
  
  // Highlight the corresponding elements
  const removeHighlight = (elements) => {
    elements.forEach(el => el.classList.remove('first-child-highlight', 'highlight'));
  };

  if (stackedWrapper.length > index) {
    removeHighlight(stackedWrapper);
    stackedWrapper[index].classList.add('highlight');
  }

  if (tabsWrapper.length > index) {
    removeHighlight(tabsWrapper);
    tabsWrapper[index].classList.add('highlight');
  }

  if (swiperSlides.length > index) {
    removeHighlight(swiperSlides);
    swiperSlides[index].classList.add('highlight');
  }
    
}

// Call highlightCurrentTab as part of initialization
initTabs() {
  const tabs = this.tabset.querySelectorAll('.tab-header input');
  const panels = this.tabset.querySelectorAll('.tab-panels .tab-panel-content');
  
  tabs.forEach((tab, index) => {
    tab.addEventListener('change', () => {
      if (tab.checked) {
        if (this.handleTabNavigation(tab)) {
          return;
        }
       
         panels.forEach(panel => panel.classList.remove('active'));
         panels.forEach(panel => (panel.style.display = 'none')); 
        
         panels[index].classList.add('active');
         panels[index].style.display = 'flex'; 
        
        this.applyHighlight(index);
      }
    });
  });

  // Call highlightCurrentTab immediately after adding event listeners
  this.highlightCurrentTab();
}

  handleTabNavigation(tab) {
    const url = tab.dataset.url;
    if (url && url.trim() !== '') {
      window.location.href = url;
      return true;
    }
    return false;
  }


  initSyncWithSwiper() {
  const tabs = this.tabset.querySelectorAll('.tab-header input');
  const panels = this.tabset.querySelectorAll('.tab-panels .tab-panel-content');
  const swiperSlides = this.tabset.querySelectorAll('.swiper-slide');

  // Synchronize when Swiper changes slides
  this.swiper.on('slideChange', () => {
    const activeIndex = this.swiper.realIndex;

    // Update tabs and panels
    tabs.forEach((tab, index) => {
        if (index === activeIndex) {
          tab.checked = true;
          
           if (this.handleTabNavigation(tab)) {
            return;
          }
          
          panels.forEach(panel => (panel.style.display = 'none')); 
          panels[index].style.display = 'flex'; 
  
          swiperSlides.forEach(slide => slide.classList.remove('highlight'));
          swiperSlides[index].classList.add('highlight'); 
        }
      });
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('change', () => {
        if (tab.checked) {
          if (this.handleTabNavigation(tab)) {
            return;
          }
          panels.forEach(panel => (panel.style.display = 'none')); 
          panels[index].style.display = 'flex';
  
          swiperSlides.forEach(slide => slide.classList.remove('highlight'));
          swiperSlides[index].classList.add('highlight');
  
          this.swiper.slideTo(index);
        }
      });
    });
}

  initDropdown() {
    const selectElement = this.tabset.querySelector('.dropdown-tabs select');
    if (!selectElement) return;

    selectElement.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      const tabUrl = selectedOption.dataset.url;
      const tabIndex = Array.from(selectElement.options).indexOf(selectedOption);
      
      if (tabUrl) {
        window.location.href = tabUrl;  // Navigate to the URL
      } else {
        this.highlightTab(tabIndex);
      }
    });
  }

  highlightTab(index) {
    const tabs = this.tabset.querySelectorAll('.tab-header input');
    const panels = this.tabset.querySelectorAll('.tab-panels .tab-panel-content');
    
    tabs.forEach((tab, i) => {
      tab.checked = (i === index);
    });

    panels.forEach(panel => panel.classList.remove('active'));
    panels.forEach(panel => (panel.style.display = 'none')); 
    panels[index].classList.add('active');
    panels[index].style.display = 'flex'; // Show the active tab panel

    if (this.swiper) {
      this.swiper.slideTo(index); // Sync with swiper if it’s initialized
    }
  }
  
}

(function(message) {
    
// Automatically initialize SwiperTabsClass for each tabset
  const tabsets = document.querySelectorAll('.tabset');
  if(tabsets.length > 0){
    tabsets.forEach(tabset => {
      const id = tabset.id || `tabset-${Math.random().toString(36).substr(2, 9)}`;
      const layout = tabset.dataset.layout || "horizontal";
      
      tabset.id = id; 
      tabset.dataset.layout = layout;
      
      new SwiperTabsClass(tabset);
    })
  }
})();